declare const CRUserInfo: any;

export default () => {
    return new Promise((resolve) => {
        if (typeof CRUserInfo !== "undefined" && typeof CRUserInfo.ready === "function") {
            CRUserInfo.ready().then(() => {
                resolve();
            });
        } else {
            document.addEventListener("userInfo_ready", () => {
                resolve();
            });
        }
    });
};



// WEBPACK FOOTER //
// ./resources/modules/utilities/getUserInfo.ts